export default __webpack_public_path__ + "static/media/Group.857db4eb.svg";